<template>
  <button
    type="button"
    @click="onClick"
    class="flex items-center text-slate-500 hover:text-slate-800 transition-colors group cursor-pointer bg-transparent border-none p-0"
  >
    <div class="flex items-center justify-center w-8 h-8 rounded-full group-hover:bg-slate-100 transition-all mr-1">
      <BaseIcon size="sm">arrow_back</BaseIcon>
    </div>
    <span v-if="label" class="text-sm font-bold uppercase tracking-wide">{{ label }}</span>
  </button>
</template>

<script setup lang="ts">
import { useNavigation } from '@/composables/useNavigation';
import BaseIcon from '@/components/base/BaseIcon.vue';

const props = withDefaults(defineProps<{
  to?: string;
  label?: string;
  // When true, the click is handed back to the parent via `@back` instead of doing router
  // navigation. Use for state-based sub-views (e.g. a view swapped in locally) where a real
  // router back would leave the page.
  emitBack?: boolean;
}>(), {
  to: '/',
  emitBack: false,
});

const emit = defineEmits<{ (e: 'back'): void }>();

const { smartBack } = useNavigation();

function onClick() {
  if (props.emitBack) {
    emit('back');
    return;
  }
  smartBack(props.to);
}
</script>
